import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { settingsApi } from '../api/endpoints';
import { isSocialLinkActive, resolveSocialHref } from '../utils/socialLink';
import SocialIcon from './SocialIcon';
import './FixedSocialLinks.css';

export default function FixedSocialLinks() {
  const location = useLocation();
  const [links, setLinks] = useState([]);
  const [whatsapp, setWhatsapp] = useState(null);

  useEffect(() => {
    if (location.pathname.startsWith('/admin')) return undefined;
    settingsApi
      .get()
      .then((res) => {
        const data = res.data?.data || {};
        setWhatsapp(data.whatsapp || null);
        setLinks((data.socialLinks || []).filter((l) => isSocialLinkActive(l, data.whatsapp)));
      })
      .catch(() => {
        setLinks([]);
        setWhatsapp(null);
      });
    return undefined;
  }, [location.pathname]);

  if (location.pathname.startsWith('/admin') || links.length === 0) {
    return null;
  }

  return (
    <aside className="fixed-social" aria-label="Social media links">
      {links.map((link, idx) => {
        const href = resolveSocialHref(link, whatsapp);
        if (!href) return null;
        return (
          <a
            key={`${link.platform}-${idx}`}
            href={href}
            className="fixed-social__link"
            target="_blank"
            rel="noreferrer noopener"
            title={link.label || link.platform}
          >
            <SocialIcon platform={link.platform} />
          </a>
        );
      })}
    </aside>
  );
}
